(function (angular) {
    'use strict';

    angular.module('app')
        .controller('pickFeaturedPollController', pickFeaturedPollController);

    pickFeaturedPollController.$inject = [
        '$uibModalInstance',
        'PollsApi'
    ];

    function pickFeaturedPollController(
        $uibModalInstance,
        PollsApi
    ) {
        var vm = this;

        // properties
        vm.isLoading = false;
        vm.polls = {};
        vm.filters = {
            status: 'approved',
            title: '',
            page: 1
        };

        // methods
        vm.dismiss = $uibModalInstance.dismiss;
        vm.getPolls = getPolls;
        vm.pickPoll = pickPoll;

        /**
         * Retrieves Events from the API
         * @return {void}
         */
        function getPolls() {
            vm.isLoading = true;
            PollsApi.get(vm.filters, function handlePollsResponse(response) {
                vm.polls = response;
                vm.isLoading = false;
            }, function handlePollsError() {
                vm.isLoading = false;
            });
        }

        /**
         * Returns the chosen poll to parent controller
         * @param  {object} poll - API event  object
         * @return {void}
         */
        function pickPoll(post) {
            $uibModalInstance.close(post);
        }

        getPolls();
    }

}(angular));
